import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./styles.css";

/** Punto de entrada del cliente: monta la aplicación sobre el contenedor de `index.html`. */
const container = document.getElementById("root");
if (!container) {
  throw new Error("Falta el contenedor #root en index.html.");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
